import React from 'react'
import {Route, Switch, withRouter, Redirect} from 'react-router-dom'
import AccountOverview from './AccountOverview'

const SMPrimeWalletRoutes = ({match: {path,url}}) => (
  <Switch>
    <Redirect from={`${path}/transactions`}  to={{pathname: '/transactions/:accountId/deposit', state: {prevPath: url}}}/>
    <Route exact path={`${path}`} component={AccountOverview} />
  </Switch>
)

export default withRouter(SMPrimeWalletRoutes)
